export default function (element) {
  const $row = element.closest('tr')
  const $currentExportAttachment = $row.find('.export-attachment')
  const $exportAccountInput = $row.find('.export-account-check input')
  const $exportAttachmentInput = $row.find('.export-attachment input')

  if ($exportAccountInput.prop('checked')) {
    return $currentExportAttachment.find('i').show()
  } else {
    $exportAttachmentInput.prop('checked', false)
    return $currentExportAttachment.find('i').hide()
  }
}
